/**
 * Canonical permission codes for SDA (analytics platform) and Survey modules.
 * Assigned per role in Roles admin; loaded from SDA via GET /auth.
 */

/** Dashboard, data, and analytics capabilities (non-survey). */
export const SDA_PLATFORM_PERMISSIONS = [
  'access_my_dashboards',
  'access_all_dashboards',
  'create_dashboard',
  'edit_dashboard',
  'share_dashboard',
  'share_folder',
  'upload_data',
  'view_analytics',
  'view_shared_dashboards',
];

/** Survey authoring and responses (enforced on routes and Survey Runtime API). */
export const SURVEY_PERMISSIONS = [
  'create_survey',
  'delete_survey',
  'manage_survey',
  'publish_survey',
  'update_survey',
  'view_responses',
  'view_survey',
];

/** Admin / tenant management (treated as SDA platform access for survey-only detection). */
export const SDA_ADMIN_PERMISSIONS = [
  'manage_users',
  'manage_tenants',
  'manage_roles',
  'view_data',
  'edit_data',
];

export const ALL_SDA_NON_SURVEY_PERMISSIONS = [
  ...SDA_PLATFORM_PERMISSIONS,
  ...SDA_ADMIN_PERMISSIONS,
];

export function hasAnyPermission(userPermissions, codes) {
  const granted = new Set(userPermissions ?? []);
  return codes.some((code) => granted.has(code));
}

export function hasAnySurveyPermission(userPermissions) {
  return hasAnyPermission(userPermissions, SURVEY_PERMISSIONS);
}

export function hasAnySdaPlatformPermission(userPermissions) {
  return hasAnyPermission(userPermissions, ALL_SDA_NON_SURVEY_PERMISSIONS);
}

/**
 * User has at least one survey permission and no SDA dashboard/data/admin permissions.
 * These users land on /survey (Overview) after login.
 */
export function isSurveyOnlyUser(userPermissions) {
  if (!hasAnySurveyPermission(userPermissions)) {
    return false;
  }
  return !hasAnySdaPlatformPermission(userPermissions);
}
